import { parseJwt } from "src/apis/auth";
import { Id } from "../types";

const EEZYCARE_HAS_CHANGED_PASSWORD_KEY = "EEZYCARE_HAS_CHANGED_PASSWORD"
const EEZYCARE_TOKEN_KEY = "EEZYCARE_TOKEN"

export function storeToken(token: string) {
    return sessionStorage.setItem(EEZYCARE_TOKEN_KEY, token);
}

export function getStoredToken() {
    return sessionStorage.getItem(EEZYCARE_TOKEN_KEY);
}

export function removeStoredToken() {
    return sessionStorage.removeItem(EEZYCARE_TOKEN_KEY);
}

const getUserType = (): string => {
    const user = parseJwt(getStoredToken());
    if (!user) {
        return "NONE"
    }

    return user.type;
}

export const getUserId = (): Id => {
    const user = parseJwt(getStoredToken());
    if (!user) {
        return undefined;
    }

    return user.user_id;
}

export const getUserCompanyId = (): Id => {
    const user = parseJwt(getStoredToken());
    if (!user) {
        return undefined;
    }

    return user.empresa_id;
}

export const getUserName = (): string => {
    const user = parseJwt(getStoredToken());
    if (!user) {
        return ""
    }

    return user.name;
}

export const getUserEmail = (): string => {
    const user = parseJwt(getStoredToken());
    if (!user || !user.email) {
        return ""
    }

    return user.email;
}

// EezyOne ligado por padrão; só é false quando a empresa comprou apenas o EezyGuard.
export const isEezyoneEnabled = (): boolean => {
    const user = parseJwt(getStoredToken());
    if (!user) {
        return true;
    }

    return user.eezyone_enabled !== false;
}

export const isUserPsychologist = (): boolean => {
    const userType = getUserType();

    return userType === "PSICOLOGO" || userType === "ADMINISTRADOR"
}

export const isUserCompany = (): boolean => {
    const userType = getUserType();

    return userType === "EMPRESA" || userType === "ADM-EMPRESA" || userType === "ADMINISTRADOR"
}

// ADM-EMPRESA tem acesso nativo ao EezyGuard; EMPRESA comum não.
export const isUserCompanyAdmin = (): boolean => {
    const userType = getUserType();

    return userType === "ADM-EMPRESA" || userType === "ADMINISTRADOR"
}

export const isUserAdministrator = (): boolean => {
    const userType = getUserType();

    return userType === "ADMINISTRADOR"
}

export const setHasChangedPassword = (changed: boolean): void => {
    localStorage.setItem(`${EEZYCARE_HAS_CHANGED_PASSWORD_KEY}_${getUserId()}`, changed ? "TRUE" : "FALSE");
}

export const hasChangedPassword = (): boolean => {
    const hasChangedPassword = localStorage.getItem(`${EEZYCARE_HAS_CHANGED_PASSWORD_KEY}_${getUserId()}`);
    if (!hasChangedPassword) {
        return false;
    }

    return hasChangedPassword === "TRUE";
}
